export default __webpack_public_path__ + "static/media/cp_geo_cx.e5097191.svg";